import { onUnmounted, getCurrentInstance } from '@vue/composition-api'

export default function tryOnUnmounted(callback) {
  if (getCurrentInstance()) {
    onUnmounted(callback)
  }
}
